export interface SessionTokens {
  accessToken: string;
  refreshToken?: string;
}

const STORAGE_KEY = "bizconnectpay_access_token";
const REFRESH_STORAGE_KEY = "bizconnectpay_refresh_token";

let memoryTokens: SessionTokens | null = null;

export const tokenStore = {
  clear() {
    memoryTokens = null;
    try {
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(REFRESH_STORAGE_KEY);
      }
    } catch {
      // Ignore storage errors in restrictive environments
    }
  },
  get(): SessionTokens | null {
    if (memoryTokens) return memoryTokens;
    try {
      if (typeof sessionStorage !== "undefined") {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        if (stored) {
          const storedRefresh = sessionStorage.getItem(REFRESH_STORAGE_KEY);
          memoryTokens = {
            accessToken: stored,
            refreshToken: storedRefresh ?? undefined,
          };
          return memoryTokens;
        }
      }
    } catch {
      // Ignore storage errors
    }
    return null;
  },
  set(tokens: SessionTokens) {
    memoryTokens = {
      accessToken: tokens.accessToken,
      refreshToken: tokens.refreshToken,
    };
    try {
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.setItem(STORAGE_KEY, tokens.accessToken);
        if (tokens.refreshToken) {
          sessionStorage.setItem(REFRESH_STORAGE_KEY, tokens.refreshToken);
        } else {
          sessionStorage.removeItem(REFRESH_STORAGE_KEY);
        }
      }
    } catch {
      // Ignore storage errors
    }
  },
};
